export default __webpack_public_path__ + "static/media/timer-app-icon.46c6927d.png";